import { OverflowTooltip } from '@/components/ui/OverflowTooltip';
import { formatSecondsToHours } from '@/lib/utils/common/formatSecondsToHours';
import { isFiniteNumber } from '@/lib/utils/common/number';

export const DurationCell = ({ value }: { value?: number }) =>
  isFiniteNumber(value) && <OverflowTooltip>{formatSecondsToHours(value)}</OverflowTooltip>;
